import { render, staticRenderFns } from "./PageOpportunityForms.vue?vue&type=template&id=abf36964"
import script from "./PageOpportunityForms.vue?vue&type=script&lang=js"
export * from "./PageOpportunityForms.vue?vue&type=script&lang=js"
import style0 from "./PageOpportunityForms.vue?vue&type=style&index=0&id=abf36964&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports